export default __webpack_public_path__ + "static/media/ML_MUSTANG_BONDY.1e07d296.pdf";